<template>
  <!-- 审计报告 -->
  <div id="auditing">
    <div class="register-img">
      <img src="./images/组 2916.png" alt />
    </div>
    <!-- 审计服务 -->
    <div class="auditing-serve">
      <h1 class="serve-h1">审计服务</h1>
      <div class="serve-content">
        <div class="content-item">
          <img src="./images/组 2917.png" alt />
          <span></span>
          <h4>年度财务报表审计</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2918.png" alt />
          <span></span>
          <h4>所得税汇算清缴审计</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2919.png" alt />
          <span></span>
          <h4>土地增值税清算</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2920.png" alt />
          <span></span>
          <h4>各类退税审计</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2921.png" alt />
          <span></span>
          <h4>政府补助专项审计</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2922.png" alt />
          <span></span>
          <h4>内控/离任审计</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2923.png" alt />
          <span></span>
          <h4>研发费用审计</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2924.png" alt />
          <span></span>
          <h4>尽职调查</h4>
        </div>
      </div>
    </div>
    <!-- 审计流程 -->
    <div class="process">
      <h1 class="process-h1">审计流程</h1>
      <div class="process-flow">
        <div class="item">
          <img src="./images/组 2925.png" alt />
          <h4>事前沟通</h4>
        </div>
        <div class="img">
          <img src="./images/路径 2873.png" alt />
        </div>
        <div class="item">
          <img src="./images/组 2926.png" alt />
          <h4>签约合同</h4>
        </div>
        <div class="img">
          <img src="./images/路径 2873.png" alt />
        </div>
        <div class="item">
          <img src="./images/组 2927.png" alt />
          <h4>列明需要资料清单</h4>
        </div>
        <div class="img">
          <img src="./images/路径 2873.png" alt />
        </div>
        <div class="item">
          <img src="./images/组 2928.png" alt />
          <h4>注册会计师/税务师团队开展审计</h4>
        </div>
        <div class="img">
          <img src="./images/路径 2873.png" alt />
        </div>
        <div class="item">
          <img src="./images/组 2929.png" alt />
          <h4>整理底稿和沟通</h4>
        </div>
        <div class="img">
          <img src="./images/路径 2873.png" alt />
        </div>
        <div class="item">
          <img src="./images/组 2930.png" alt />
          <h4>确认报告并交付</h4>
        </div>
      </div>
    </div>
    <!-- 成功案例 -->
    <div class="succeed">
      <div class="succeed-img">
        <img src="./images/bj14.png" alt />
      </div>
      <div class="succeed-items">
        <div class="items-middle">
          <h2 class="items-h2">成功案例</h2>
          <div class="items-imgs">
            <img src="./images/组 2845.png" alt="">
            <img src="./images/组 2846.png" alt="">
            <img src="./images/组 2847.png" alt="">
            <img src="./images/组 2848.png" alt="">
            <img src="./images/组 2849.png" alt="">
            <img src="./images/组 2850.png" alt="">
            <img src="./images/组 2851.png" alt="">
            <img src="./images/组 2852.png" alt="">
            <img src="./images/组 2853.png" alt="">
            <img src="./images/组 2854.png" alt="">
            <img src="./images/组 2855.png" alt="">
            <img src="./images/组 2856.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "auditing",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.register-img {
  width: 100%;
  min-width: 1040px;
  margin: 0 auto;
  img {
    width: 100%;
  }
}
// 审计服务
.auditing-serve {
  width: 1040px;
  margin: 40px auto;
  // padding: 0 14%;
  .serve-h1 {
    margin-bottom: 30px;
  }
  .serve-content {
    display: flex;
    flex-flow: wrap;
    .content-item {
      width: 25%;
      box-sizing: border-box;
      border: 1px solid #ccc;
      margin-bottom: -1px;
      margin-right: -1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 40%;
        padding: 10% 0;
      }
      span {
        width: 20%;
        border-top: 1px solid #ccc;
      }
      h4 {
        padding: 13% 0;
      }
    }
  }
}
// 审计流程
.process {
  width: 1040px;
  margin: 40px auto;
  margin-bottom: 50px;
  // padding: 0 14%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .process-h1 {
    margin-bottom: 30px;
  }
  .process-flow {
    height: 60px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item {
      // justify-content: space-between;
      img {
        width: 30%;
      }
      h4 {
        padding-top: 10px;
      }
    }
    .img {
      flex: 1.2;
      align-items: center;
      display: flex;
      justify-content: center;
      img {
        width: 20%;
      }
    }
  }
  .process-flow > div {
    height: 100%;
    flex: 2;
    text-align: center;
    line-height: 16px;
  }
}
// 成功案例
.succeed {
  width: 100%;
  min-width: 1040px;
  position: relative;
  .succeed-img {
    width: 100%;
    position: relative;
    left: 0;
    top: 0;
    height: 451px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .succeed-items {
    // padding: 0 14%;
    // box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    .items-middle {
      // padding: 0 14%;
      // width: 100%;
      width: 1040px;
      margin: 0 auto;
      box-sizing: border-box;
      .items-h2 {
        color: #fff;
        margin-top: 40px;
        margin-bottom: 60px;
        font-size: 23px;
        font-weight: 400;
      }
      .items-imgs {
        width: 100%;
        justify-content: space-between;
        align-content: space-between;
        img {
          width: 16%;
          margin-bottom: 3px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/auditing/auditing.vue